export const projects = [
    {
        link: "https://samscarpetservices.netlify.app/",
        title: "Sam's Carpet Services",
        description: "Designed and built a landing page for a local business utilizing Next.js and Tailwind. Website supports media darkmode",
        image: require("../img/samsApp.png"),
        iamgeAlt: "snapshot of portfolio project Sam's Carpet Service website"
    },
    {
        link: "https://budget-mern-7e102b331f36.herokuapp.com/",
        title: "Budget App",
        description: "A complete MERN app with user login and sign up. Definitely one of the apps I am most proud of",
        image: require("../img/budgetApp.png"),
        iamgeAlt: "snapshot of portfolio project Budget App"
    },
    {
        link: "https://opensac.org/",
        title: "opensac.org",
        description: "Collaborated with the opensac Civic Tech organization to recreate their organization's landing page utilizing Next.js",
        image: require("../img/opensacApp.png"),
        iamgeAlt: "snapshot of portfolio project Opensac.org"
    },
    {
        link: "https://github.com/Alisa1989/creatorverse-app",
        title: "Creatoverse App",
        description: "For this basic CRUD app I used Supabase for the Backend (a type of Firebase) and Vite.js for the frontend. It was also my first experience using Typescript.",
        image: require("../img/creatoverse.png"),
        iamgeAlt: "snapshot of portfolio project Opensac.org"
    },
    {
        link: "https://github.com/Alisa1989/othello_game",
        title: "Othello Game",
        description: "I recreated the Othello game in python",
        image: require("../img/othelloGame.png"),
        iamgeAlt: "snapshot of Othello Game"
    },
    {
        link: "https://github.com/Alisa1989/personal-website",
        title: "This Website",
        description: "This is how I built this website in React",
        image: require("../img/portfolio.png"),
        iamgeAlt: "snapshot of this website"
    },
    {
        link: "https://github.com/Alisa1989/Store64",
        title: "Store website",
        description: "Utilized React, Redux, Material UI, SASS, Express, Knex, and a SQL database to create an online store with user signup/login",
        image: require("../img/storeApp.png"),
        iamgeAlt: "snapshot of portfolio project store website"
    },
]